import React, { useState } from "react";
import { DialogContent, Stack, TextField, Typography } from "@mui/material";
import { Button, Dialog } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import moment from "moment/moment";
import { BtnCancel, CbBox } from "../styles";
import Repo from "../../Repository/Repo";
import { Toast } from "../components/Toast";

function UpdateDate({ row, onClose, onSuccess }) {
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleInput = (e) => {
    const { value } = e.target;
    setDate(value);
  };

  const handleUpdate = async () => {
    try {
      if (!date) {
        Toast("info", "Kindly select date");
        return;
      }
      setLoading(true);
      let { data } = await Repo.purchases({
        request: {
          method: "updatePurchaseDate",
          data: {
            _id: row?._id,
            date: moment(date).format("DD-MM-YYYY"),
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        Toast("success", "Date updated successfully");
        onSuccess();
        onClose();
      } else {
        Toast("error", "Error");
        setLoading(false);
        toggle();
      }
    } catch (err) {
      console.log("err:", err);
      Toast("error", err.message);
      setLoading(false);
      toggle();
    }
  };

  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing="24px">
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            Update Purchase Date
          </Typography>
          <CbBox>
            <Typography>Current Date</Typography>
            <Typography>
              {moment.unix(row.created_at).format("DD-MM-YYYY")}
            </Typography>
          </CbBox>
          <Stack>
            <Typography>Select New Date</Typography>
            <TextField
              size="small"
              fullWidth
              type="date"
              variant="outlined"
              value={date}
              onChange={handleInput}
            />
          </Stack>
          {loading && (
            <Stack direction="row" alignItems="center" justifyContent="center">
              <ClipLoader color="#4caf50" loading={loading} size={32} />
            </Stack>
          )}
          {!loading && (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-around"
            >
              <BtnCancel onClick={toggle}>Close</BtnCancel>
              <Button
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={handleUpdate}
              >
                Update
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default UpdateDate;
